import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { useState } from "react"
import { useDispatch } from "react-redux";
import { handleLogout } from '@store/authentication';
import { Link, Navigate, useNavigate } from "react-router-dom"
const Logout = () => {
    const [disabledModal, setDisabledModal] = useState(true)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const handleLogoutFunction = () => {
        dispatch(handleLogout())
        return < Navigate to='/login' replace />
    }

    const handleCancel = () => {
        setDisabledModal(!disabledModal)
        navigate('/dashboard')
    }

    return (
        <div className='disabled-backdrop-modal'>
            <Modal
                isOpen={disabledModal}
                className='modal-dialog-centered'
                backdrop={false}
            >
                <ModalHeader>Confirmation</ModalHeader>
                <ModalBody> Are you sure you want to Logout ?</ModalBody>
                <ModalFooter>
                    <Link onClick={() => handleLogoutFunction()} style={{ color: "white" }}>
                        <Button color='primary'>  Logout </Button>
                    </Link>
                    <Button type='reset' color='secondary' outline onClick={() => handleCancel()}>Cancel </Button>
                </ModalFooter>
            </Modal>
        </div>


    )
}

export default Logout
